import { render, staticRenderFns } from "./AccountAlerts.vue?vue&type=template&id=070e0761&"
import script from "./AccountAlerts.vue?vue&type=script&lang=js&"
export * from "./AccountAlerts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports